import styled, { css } from 'styled-components'

type StyleButtonProps = {
  size?: 'display' | 'mid' | 'small' | 'custom',
  customStyles?:any,
  isIcon?:boolean
  active?:boolean,
}
function styleMyEl(size:any, customStyles?:string,isIcon?:boolean) {
  switch (size) {
    case 'display':
      return css`
        padding:${isIcon ? '10px 16px 10px 13px' : '10px 16px'};
        height: 40px;
        ${customStyles}
      `;
    case 'mid':
      return css`
        padding:${isIcon ? '10px 16px 10px 13px' : '10px 16px'};
        height: 36px;
        ${customStyles}
      `;
    case 'small':
      return css`
        padding:${isIcon ? '0px 10px 0px 7px' : '0px 10px'};
        height: 30px;
        ${customStyles}
      `;
    case 'custom':
      return css`
        ${customStyles}
      `;
    default:
      return css`
        /* width: 94px; */
        height: 30px;
        ${customStyles}
      `;
  }
}
const StrokeButton = styled.button.withConfig({
  shouldForwardProp: (prop) => !['size', 'customStyles', 'isIcon', 'active'].includes(prop),
})<StyleButtonProps>`
  display: flex;
  align-items: center;
  
  background: ${({theme}) => theme.palette[10]};
  color: ${({theme}) => theme.isDark ? theme.palette[850] : theme.palette[850]};
  border-radius: ${({theme}) => theme.radius.control};
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  /* box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1); */
  border: ${({theme, active}) => active ? `1px solid ${theme.accent[100]}` : `1px solid ${theme.grey[400]}`};
  box-shadow:${({theme, active}) => active ?  theme.isDark ? theme.shadows.focusDark : theme.shadows.focus : theme.shadows.control};
  ${({size, customStyles, isIcon}) => styleMyEl(size, customStyles, isIcon)};
  &:hover:not(:disabled){
    color: ${({theme}) => theme.palette[900]};
    box-shadow: ${({theme}) => theme.shadows.hover};
    cursor: pointer;
  }
  &:active:not(:disabled){
    /* border-color: ${({theme}) => theme.primary[200]}; */
    color: ${({theme}) => theme.palette[900]};
    border: ${({theme}) => `1px solid ${theme.accent[100]}`};
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
  &:focus-visible{
    outline: none;
    border: ${({theme}) => `1px solid ${theme.accent[100]}`};
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
  &:disabled{
    background: ${({theme}) => theme.grey[100]};
    color:#858A94;
    border-color: ${({theme}) => theme.grey[400]};
    box-shadow: none;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    min-width: 0;
    max-width: 100%;
    min-height: 30px;
    height: auto;
    padding-left: 8px;
    padding-right: 8px;
    flex-shrink: 1;
    white-space: normal;
    overflow-wrap: anywhere;
  }
`

export default StrokeButton
